import { Phone, MessageSquare } from "lucide-react";

const MobileContactBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-foreground/95 backdrop-blur-xl border-t border-primary-foreground/10 safe-area-bottom">
      <div className="grid grid-cols-2 divide-x divide-primary-foreground/10">
        <a
          href="tel:+420733679995"
          className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
        >
          <Phone className="h-4 w-4" />
          Zavolat
        </a>
        <a
          href="#odhad"
          className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
        >
          <MessageSquare className="h-4 w-4" />
          Odhad zdarma
        </a>
      </div>
    </div>
  );
};

export default MobileContactBar;
